// ─── Canada Tax Filing Page — Data ───────────────────────────────────────────

export const canadaRahulPhoto = "https://customer-assets.emergentagent.com/job_cross-border-wealth/artifacts/pmgzag2g_rahul%20pic.png";
export const canadaStripeUrl = "https://buy.stripe.com/14AdR86fK7VBb4hbwigEg0l";
export const canadaWhatsappUrl = "https://wa.me/919289791199?text=Hi%2C%20I%20want%20to%20file%20my%20Canada%20T1%20Tax%20Return";
export const canadaDeadline = "April 30, 2026";

export const canadaTopBarData = {
  message: "Canada Tax Filing Deadline:",
  date: "April 30, 2026",
};

export const canadaNavData = {
  logoName: "CA Rahul Taneja",
  logoSub: "NRI TAX SPECIALIST",
  ctaText: "File Now — $40 CAD",
  links: [
    { label: "The Problem", href: "#pain" },
    { label: "What's Included", href: "#offer" },
    { label: "How It Works", href: "#how" },
    { label: "FAQ", href: "#faq" },
  ],
};

export const canadaHeroData = {
  eyebrow: "Done-For-You Canada Tax Filing",
  headline1: "Your T1 Return.",
  headline2: "Expert Filed. Flat $40.",
  headlineStrike: "Not $150.",
  sub: "Built for Indian immigrants & students in Canada. No confusion. No hidden fees. No CRA stress. Filed in 48 hours by a Chartered Accountant.",
  priceLabel: "FLAT FEE. NO SURPRISES.",
  price: "$40",
  priceCurrency: "CAD",
  priceUnit: "CAD — One-time, all inclusive",
  priceCompare: "Typical filing fees: $150–$250 — You save: $110–$210",
  ctaPrimary: "File My Return Now",
  ctaSecondary: "How It Works",
  trustItems: [
    "10+ Years CA Experience",
    "Filed in 48 Hours",
    "WhatsApp Support Included",
  ],
};

export const canadaDeadlineData = {
  message: "CRA Filing Deadline is April 30, 2026. Miss it → Penalties start at 5% + 1% per month.",
};

export const canadaPainData = {
  sectionLabel: "The Real Problem",
  headline1: "Canadian taxes confuse even smart people.",
  headline2: "Especially if you're from India.",
  sub: "You understand money. You're educated. But the Canadian tax system is a completely different language.",
  cards: [
    {
      headline: "You don't know what forms you need",
      body: "T4? T2202? T1-ADJ? RRSP receipt? GST credit? It's overwhelming — and Google makes it worse.",
    },
    {
      headline: "You're likely leaving money on the table",
      body: "Tuition carry-forward, GST/HST credit, moving expense deductions, foreign tax credits — most first-timers miss all of these.",
    },
    {
      headline: "DIY tools assume you know the system",
      body: "TurboTax and Wealthsimple are built for Canadians who grew up here. Not for someone who moved from India 2 years ago.",
    },
    {
      headline: "Standard tax prep fees are too high",
      body: "$150–$250 for a simple T1 return? For a student or new employee building their life here? There's a smarter option.",
    },
    {
      headline: "CRA notices are terrifying",
      body: '"A letter arrived from CRA" — and suddenly there\'s panic. Most of the time it\'s routine, but without a CA you don\'t know that.',
    },
    {
      headline: "Late filing kills your benefits",
      body: "Not filing = no GST credit, no provincial benefits, delayed payments. Filing late = penalties. The clock is already running.",
    },
  ],
};

export const canadaForData = {
  sectionLabel: "Is This For You?",
  headline: "This is for you if…",
  yesTitle: "Perfect For You",
  yesItems: [
    "You're an Indian immigrant on a work permit or PR in Canada",
    "You're an international student with part-time employment or stipends",
    "You have T4 income from a Canadian employer",
    "You moved to Canada in the last 1–4 years",
    "This is your first time filing a Canadian tax return",
    "You have tuition credits (T2202) to claim or carry forward",
    "You want someone who understands India-source income background",
    "You want it done right, without spending $200",
  ],
  noTitle: "NOT for you if…",
  noItems: [
    "You have self-employment / business income (separate quote needed)",
    "You own rental properties in Canada",
    "You have foreign assets over CAD $100,000 (T1135 required)",
    "You need Quebec provincial return (different process)",
    "You have capital gains from stock trading",
  ],
  noNote: "For complex situations, reach out on WhatsApp for a custom quote. Still cheaper than any CPA in Canada.",
};

export const canadaOfferData = {
  sectionLabel: "The Offer",
  headline1: "Everything you get",
  headline2: "for $40 CAD.",
  sub: "We stacked $344 worth of value into a $40 flat offer. Here's exactly what's included.",
  packageTitle: "Complete Canada Tax Filing Package",
  packageSub: "T1 Personal Return — Employment + Student Income | CRA NETFILE Certified",
  items: [
    {
      title: "T1 Personal Tax Return Filing",
      desc: "CA-prepared, NETFILE-submitted directly to CRA. Covers T4 employment income, tuition credits, RRSP deductions, and standard deductions.",
      value: "$150 value",
      tag: "Core service",
    },
    {
      title: "Refund Maximizer Review",
      desc: "We manually review your return for missed credits — tuition carry-forward, moving expenses, GST/HST credit eligibility, provincial credits.",
      value: "$50 value",
      tag: "Included",
    },
    {
      title: "Newcomer Benefits Unlock Check",
      desc: "We verify you're registered for GST/HST credit, Canada Child Benefit (if applicable), and any provincial benefit you may be missing.",
      value: "$40 value",
      tag: "Included",
    },
    {
      title: "30-Day CRA Notice Support",
      desc: "If CRA sends any letter or request after your filing, we review it and guide your response. No extra charges for 30 days.",
      value: "$75 value",
      tag: "Included",
    },
    {
      title: "Canada Tax 101 Guide — Indians Edition",
      desc: "Our plain-English PDF guide covering what every Indian newcomer must know in their first 3 tax years. No jargon, just clarity.",
      value: "$29 value",
      tag: "Included",
    },
    {
      title: "WhatsApp Direct Support",
      desc: "Have questions during the process? Message us directly on WhatsApp in English. Real CA, real answers.",
      value: "Priceless",
      tag: "Included",
    },
  ],
  totalValue: "$344+ CAD",
  yourPrice: "$40",
  yourPriceLabel: "CAD · Flat · One-time · All inclusive",
  ctaText: "Yes, File My Return for $40",
};

export const canadaHowData = {
  sectionLabel: "The Process",
  headline1: "3 steps. 48 hours.",
  headline2: "Done.",
  sub: "You don't need to understand Canadian tax law. That's our job.",
  steps: [
    {
      num: "1",
      title: "Pay & Send Your Documents",
      body: "Pay $40 online. We send you a simple WhatsApp checklist — usually just your T4 slip, T2202 (if student), and SIN number. Takes you 10 minutes.",
      detail: "Most people need: T4 (from employer), T2202 (tuition certificate), SIN card, Date of entry to Canada. That's it.",
    },
    {
      num: "2",
      title: "We Prepare & Maximize Your Return",
      body: "Our CA team prepares your T1, runs the refund maximizer, checks every credit you qualify for, and reviews it for accuracy. Ready in 48 business hours.",
      detail: "Average client result: Most newcomers and students get a refund — not a tax bill. We make sure you capture every dollar.",
    },
    {
      num: "3",
      title: "Review, Approve & Filed to CRA",
      body: "We share your completed return for review. Once you approve, we NETFILE it directly to CRA. Your refund typically arrives within 2 weeks of filing.",
      detail: "After filing: You get your T1 copy, refund confirmation, and 30-day CRA support coverage. We're with you every step.",
    },
  ],
};

export const canadaFAQData = {
  sectionLabel: "Questions You're Thinking",
  headline1: "Answering your",
  headline2: "doubts directly.",
  items: [
    {
      q: "Why is it only $40? Is this legit?",
      a: "Yes, completely legit. We're a digital-first practice with 10+ years of CA experience. We serve high-volume clients across UAE, India, and Canada, which means our cost per return is low — and we pass that saving to you. No Canadian office rent. No $300/hour overhead. Just expert service at a fair price.",
    },
    {
      q: "I have income from India too. Can you handle that?",
      a: "Yes. If you became a Canadian tax resident, your India-source income must be disclosed. But the India-Canada DTAA prevents double taxation. We understand both systems, properly apply foreign tax credits, and ensure you're not paying tax on the same income twice.",
    },
    {
      q: "I don't have all my documents ready. What do I do?",
      a: "That's completely fine. After you sign up, we send you a simple WhatsApp checklist. Most simple returns need only 2–3 documents. We guide you step by step on what to collect.",
    },
    {
      q: "What if CRA contacts me after filing?",
      a: "Your package includes 30 days of CRA notice support. If CRA sends any letter — notice of assessment, request for information, anything — forward it to us and we'll review it and tell you exactly what to do.",
    },
    {
      q: "What if I worked at multiple jobs?",
      a: "Multiple T4s (multiple employers) are still covered in the $40 flat fee. This is standard for students and part-time workers. Just share all your T4 slips and we handle it in one return.",
    },
    {
      q: "I didn't earn much last year. Do I still need to file?",
      a: "YES — and this is the biggest mistake newcomers make. Even with zero income, you should file because: (1) CRA needs your residency status, (2) GST/HST credit and CCB payments are triggered by filing, (3) Tuition credits can be carried forward to future years when you earn more.",
    },
    {
      q: "Can I file my previous years too? I haven't filed since I came to Canada.",
      a: "Yes. You can file back-years with CRA. Each year is a separate return priced accordingly. Many clients come with 2–3 unfiled years. We handle all of them and help you get back-owed refunds + benefits. Message us on WhatsApp for a custom quote.",
    },
  ],
};

export const canadaGuaranteeData = {
  headline: "Our Ironclad Guarantee",
  body1: "If your return is not filed within 48 business hours of receiving your complete documents, we refund $10 from your fee. Automatically.",
  body2: "If you're not completely satisfied with our service, we'll make it right. That's our promise.",
};

export const canadaTestimonialData = {
  sectionLabel: "Client Stories",
  headline1: "Indians who finally stopped stressing",
  headline2: "about Canadian taxes.",
  items: [
    {
      text: "I was overwhelmed before this — had no idea what to file or even where to start. CA Rahul walked me through everything and my return was filed in 2 days. Got a $180 refund I didn't even know I was owed.",
      name: "Arjun M.",
      meta: "Software Engineer, Toronto · PR holder",
    },
    {
      text: "As an international student juggling part-time work and studies, I had no idea about the tuition credit carry-forward. They found an extra $400 in credits I was completely unaware of. Worth every cent.",
      name: "Priya S.",
      meta: "Masters Student, University of Calgary",
    },
    {
      text: "I'd been in Canada for 3 years but kept putting off filing out of fear it would cost a fortune. Got all 3 years sorted here for a fraction of what any local accountant quoted me. Wish I'd found this sooner.",
      name: "Manish K.",
      meta: "Registered Nurse, Vancouver · 3 years unfiled",
    },
  ],
};

export const canadaFinalCtaData = {
  urgencyTag: "Only 18 days until CRA deadline",
  headline1: "File it. Get your refund.",
  headline2: "Stop stressing about it.",
  sub: "Stop procrastinating. The deadline is real. CRA late-filing penalties are real. Your refund is real — but only if you claim it.",
  ctaText: "File My Return — $40 CAD",
  trustItems: ["Satisfaction Guaranteed", "Filed in 48 Hours", "WhatsApp Support"],
};

export const canadaFooterData = {
  brandName: "Finpire Global Accounting & Auditing Co. LLC",
  tagline: "CA Rahul Taneja  |  @ca_rahul_dxb  |  Dubai, UAE",
  subline: "Serving NRIs across UAE, India & Canada for 10+ years",
  disclaimer: "This is a professional tax preparation service. CA Rahul Taneja is not responsible for client-provided inaccurate information. All returns filed are subject to CRA review.",
};
